import React from 'react';
import Box from '@mui/material/Box';
import theme from '../../theme';

export interface WithBoxStyleProps {
  children: React.ReactNode;
}

const withBoxStyle = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const WithBoxStyle = (props: P) => (
    <Box
      sx={{ background: theme.palette?.bg?.main }}
      className="d-flex flex-column flex-1"
    >
      <WrappedComponent {...props} />
    </Box>
  );

  return WithBoxStyle;
};

export default withBoxStyle;
